// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shared container styles */
.prearrival-container {
    padding: 30px;
    max-width: 1200px;
    margin: auto;
    font-family: 'Segoe UI', sans-serif;
    background: #ffffff;
}

    /* Title */
    .prearrival-container h2 {
        font-size: 24px;
        margin-bottom: 25px;
        color: #1e3a8a;
        text-align: center;
    }

/* Table styling (common) */
.prearrival-table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 30px;
    background: #f9fafb;
    border-radius: 6px;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(0,0,0,0.08);
}

    .prearrival-table th,
    .prearrival-table td {
        padding: 12px 15px;
        text-align: left;
        border-bottom: 1px solid #e5e7eb;
        font-size: 14px;
    }

    .prearrival-table th {
        background-color: #e0e7ff;
        font-weight: 600;
        color: #1e3a8a;
    }

    .prearrival-table tr:hover {
        background-color: #f3f4f6;
    }

/* View button */
.view-button {
    padding: 6px 12px;
    font-size: 13px;
    border: none;
    background-color: #2563eb;
    color: white;
    border-radius: 4px;
    cursor: pointer;
}

    .view-button:hover {
        background-color: #1e40af;
    }

/* View page layout */
.prearrival-view {
    background-color: #ffffff;
    border-radius: 8px;
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.1);
    padding: 30px;
    margin-top: 20px;
}

/* Section header */
.detail-section {
    margin-bottom: 30px;
}

    .detail-section h3 {
        font-size: 18px;
        margin-bottom: 10px;
        color: #1e3a8a;
    }

    /* Detail table */
    .detail-section table {
        width: 100%;
        border-collapse: collapse;
    }

    .detail-section td {
        padding: 10px;
        border-bottom: 1px solid #e5e7eb;
        vertical-align: top;
        font-size: 14px;
    }

        .detail-section td:first-child {
            font-weight: 600;
            width: 35%;
            color: #374151;
        }

/* Links */
a {
    color: #2563eb;
    text-decoration: none;
}

    a:hover {
        text-decoration: underline;
    }

/* Not found */
.not-found {
    color: #b91c1c;
    font-weight: bold;
    text-align: center;
    padding: 30px;
}

/* Back link */
.back-link {
    margin-top: 30px;
    text-align: center;
    font-size: 14px;
}

.prearrival-container {
    background-color: #f8f9fb;
    min-height: 100vh;
}

.prearrival-dashboard-content {
    padding: 20px 30px;
}

.filter-bar {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 15px;
}

    .filter-bar input {
        flex: 1 1 200px;
        padding: 8px;
        font-size: 14px;
        border: 1px solid #ccc;
        border-radius: 4px;
    }

.table-responsive {
    width: 100%;
    overflow-x: auto;
}

.prearrival-table {
    width: 100%;
    border-collapse: collapse;
    background-color: #fff;
}

    .prearrival-table th,
    .prearrival-table td {
        padding: 12px 10px;
        border: 1px solid #ddd;
        text-align: left;
        white-space: nowrap;
    }

    .prearrival-table th {
        background-color: #eaf0ff;
        font-weight: bold;
        cursor: pointer;
    }

.view-btn {
    background-color: #007bff;
    border: none;
    color: white;
    padding: 6px 10px;
    border-radius: 4px;
    cursor: pointer;
}

    .view-btn:hover {
        background-color: #0056b3;
    }

/* Badge Styles */
.badge {
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;
    color: white;
    display: inline-block;
}

.badge-submitted {
    background-color: #28a745;
}

.badge-draft {
    background-color: #ffc107;
    color: black;
}

.badge-cancelled {
    background-color: #dc3545;
}
.full-width {
    width: 100%;
}

.table-responsive {
    overflow-x: auto;
}

.filter-bar {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 16px;
}

    .filter-bar input {
        padding: 8px;
        width: 180px;
        border: 1px solid #ccc;
        border-radius: 4px;
    }

.badge {
    padding: 4px 8px;
    border-radius: 6px;
    color: white;
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
}

.badge-submitted {
    background-color: #28a745;
}

.badge-draft {
    background-color: #ffc107;
    color: black;
}

.badge-cancelled {
    background-color: #dc3545;
}

.view-btn {
    padding: 4px 10px;
    background: #007bff;
    border: none;
    color: white;
    border-radius: 4px;
    cursor: pointer;
}
.card-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
    gap: 1.5rem;
    margin-top: 20px;
}

.info-card {
    background-color: #fff;
    border-radius: 8px;
    padding: 1.25rem;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
    transition: 0.3s;
}

    .info-card h3 {
        margin-bottom: 0.75rem;
        color: #333;
    }

    .info-card p {
        margin: 0.25rem 0;
        color: #444;
    }

.doc-list {
    padding-left: 1rem;
}

    .doc-list li {
        margin-bottom: 0.4rem;
    }

.status-badge {
    padding: 0.25rem 0.5rem;
    border-radius: 4px;
    font-size: 0.85rem;
    color: white;
    background-color: #666;
}

    .status-badge.submitted {
        background-color: #2e7d32;
    }

    .status-badge.draft {
        background-color: #b71c1c;
    }

.view-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.back-button {
    background-color: #ccc;
    border: none;
    padding: 0.4rem 0.8rem;
    border-radius: 5px;
    cursor: pointer;
}
.dashboard-body {
    display: flex;
    min-height: calc(100vh - 150px); /* adjust based on header/footer height */
}

.dashboard-content {
    flex: 1 1;
    padding: 20px;
    overflow-y: auto;
}
/* === ANALYTICS DASHBOARD STYLES === */

.analytics-section {
    background-color: #ffffff;
    padding: 25px;
    border-radius: 10px;
    margin-bottom: 30px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
}

    .analytics-section h3 {
        font-size: 20px;
        color: #1e3a8a;
        margin-bottom: 16px;
        border-bottom: 2px solid #e0e7ff;
        padding-bottom: 6px;
    }

/* Chart Containers */
.chart-container {
    width: 100%;
    height: 320px;
    margin-bottom: 20px;
    background: #f0f4ff;
    padding: 10px;
    border-radius: 6px;
    box-shadow: inset 0 0 3px #cbd5e1;
}

/* Heatmap specific */
.heatmap-chart {
    height: 280px;
    background-color: #fff3cd;
    border: 1px dashed #f0ad4e;
    border-radius: 6px;
    padding: 12px;
    overflow-x: auto;
}

/* Geo Map */
.geo-map {
    height: 350px;
    width: 100%;
    background-color: #f0f9ff;
    border-radius: 8px;
    border: 1px solid #cfe2ff;
    position: relative;
}

/* Checklist Pie / Bar */
.compliance-chart {
    height: 280px;
    background: #e3fcef;
    border: 1px solid #b2f5ea;
    border-radius: 6px;
    padding: 10px;
}

/* Risk/Health Alerts */
.alert-card {
    background-color: #fff4e5;
    border-left: 6px solid #ff9f43;
    padding: 12px 20px;
    margin-bottom: 14px;
    border-radius: 6px;
    color: #663c00;
}

    .alert-card.critical {
        background-color: #fdecea;
        border-left-color: #e3342f;
        color: #a00000;
    }

/* ETA Live Ticker */
.live-ticker {
    background-color: #e6f7ff;
    border-left: 5px solid #007bff;
    padding: 10px 18px;
    font-size: 15px;
    font-weight: 500;
    border-radius: 4px;
    margin-bottom: 16px;
}

/* Responsive Dashboard Grid */
.dashboard-analytics-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(340px, 1fr));
    gap: 24px;
    margin-top: 20px;
}

.dashboard-header {
    font-size: 26px;
    font-weight: bold;
    color: #1e3a8a;
    margin-bottom: 20px;
    text-align: center;
}

/* Chart Placeholder */
.chart-placeholder {
    height: 250px;
    background-color: #eef2f7;
    border-radius: 8px;
    border: 1px dashed #94a3b8;
    display: flex;
    align-items: center;
    justify-content: center;
    font-style: italic;
    color: #64748b;
}
/* Core Layout */
/* PreArrivalDashboard.css */
/* Layout */
.dashboard {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
}

.dashboard-body {
    display: flex;
    flex-grow: 1;
    overflow-x: hidden;
}

.dashboard-content {
    flex: 1 1;
    padding: 20px;
    background-color: #f9f9f9;
}

/* Tabs */
.dashboard-tabs {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 15px;
    flex-wrap: wrap;
}

    .dashboard-tabs button {
        background-color: #e0e0e0;
        border: none;
        padding: 10px 14px;
        border-radius: 6px;
        cursor: pointer;
        font-weight: bold;
        display: flex;
        align-items: center;
        gap: 6px;
    }

        .dashboard-tabs button.active {
            background-color: #2196f3;
            color: white;
        }

/* Cards Layout */
.cards-container {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
}

.chart-card {
    background-color: white;
    border-radius: 8px;
    padding: 16px;
    box-shadow: 0 2px 5px rgba(0,0,0,0.1);
    flex: 1 1 45%;
    position: relative;
}

    .chart-card.full-width {
        flex: 1 1 100%;
    }

    .chart-card h3 {
        margin-bottom: 10px;
    }

.card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
}

.chart-description {
    font-size: 13px;
    color: #666;
    margin-top: 10px;
}

/* Map Container */
.map-card {
    background-color: white;
    border-radius: 8px;
    padding: 16px;
    margin-top: 20px;
    box-shadow: 0 2px 5px rgba(0,0,0,0.1);
}

.leaflet-map {
    height: 400px;
    border-radius: 8px;
    margin-top: 10px;
    z-index: 0;
}

/* Alert Cards */
.alert-card {
    padding: 20px;
    border-radius: 8px;
    margin-bottom: 12px;
    color: white;
    font-weight: bold;
}

    .alert-card.red {
        background-color: #d32f2f;
    }

    .alert-card.yellow {
        background-color: #fbc02d;
        color: black;
    }

    .alert-card.orange {
        background-color: #fb8c00;
    }

/* Pie Slice Colors */
.pie-slice-color-0 {
    fill: #ffc107 !important;
}

.pie-slice-color-1 {
    fill: #ab47bc !important;
}

.pie-slice-color-2 {
    fill: #29b6f6 !important;
}

.pie-slice-color-3 {
    fill: #66bb6a !important;
}

.pie-slice-color-4 {
    fill: #ffa726 !important;
}

.pie-slice-color-5 {
    fill: #8d6e63 !important;
}

.filter-message {
    margin-bottom: 10px;
    color: #1e88e5;
    font-weight: bold;
}

/* Responsive */
@media screen and (max-width: 768px) {
    .cards-container {
        flex-direction: column;
    }

    .chart-card {
        flex: 1 1 100%;
    }

    .dashboard-tabs {
        flex-direction: column;
        align-items: flex-start;
    }
}

.button {
    padding: 8px 16px;
    border: none;
    background-color: #000000;
    color: white;
    font-weight: 600;
    border-radius: 4px;
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/pages/demo/PreArrival/PreArrivalDashboard.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;IACI,aAAa;IACb,iBAAiB;IACjB,YAAY;IACZ,mCAAmC;IACnC,mBAAmB;AACvB;;IAEI,UAAU;IACV;QACI,eAAe;QACf,mBAAmB;QACnB,cAAc;QACd,kBAAkB;IACtB;;AAEJ,2BAA2B;AAC3B;IACI,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,sCAAsC;AAC1C;;IAEI;;QAEI,kBAAkB;QAClB,gBAAgB;QAChB,gCAAgC;QAChC,eAAe;IACnB;;IAEA;QACI,yBAAyB;QACzB,gBAAgB;QAChB,cAAc;IAClB;;IAEA;QACI,yBAAyB;IAC7B;;AAEJ,gBAAgB;AAChB;IACI,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;IAEI;QACI,yBAAyB;IAC7B;;AAEJ,qBAAqB;AACrB;IACI,yBAAyB;IACzB,kBAAkB;IAClB,sCAAsC;IACtC,aAAa;IACb,gBAAgB;AACpB;;AAEA,mBAAmB;AACnB;IACI,mBAAmB;AACvB;;IAEI;QACI,eAAe;QACf,mBAAmB;QACnB,cAAc;IAClB;;IAEA,iBAAiB;IACjB;QACI,WAAW;QACX,yBAAyB;IAC7B;;IAEA;QACI,aAAa;QACb,gCAAgC;QAChC,mBAAmB;QACnB,eAAe;IACnB;;QAEI;YACI,gBAAgB;YAChB,UAAU;YACV,cAAc;QAClB;;AAER,UAAU;AACV;IACI,cAAc;IACd,qBAAqB;AACzB;;IAEI;QACI,0BAA0B;IAC9B;;AAEJ,cAAc;AACd;IACI,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;AACjB;;AAEA,cAAc;AACd;IACI,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,mBAAmB;AACvB;;IAEI;QACI,eAAe;QACf,YAAY;QACZ,eAAe;QACf,sBAAsB;QACtB,kBAAkB;IACtB;;AAEJ;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,sBAAsB;AAC1B;;IAEI;;QAEI,kBAAkB;QAClB,sBAAsB;QACtB,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,yBAAyB;QACzB,iBAAiB;QACjB,eAAe;IACnB;;AAEJ;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;IAEI;QACI,yBAAyB;IAC7B;;AAEJ,iBAAiB;AACjB;IACI,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,mBAAmB;AACvB;;IAEI;QACI,YAAY;QACZ,YAAY;QACZ,sBAAsB;QACtB,kBAAkB;IACtB;;AAEJ;IACI,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,aAAa;IACb,2DAA2D;IAC3D,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,wCAAwC;IACxC,gBAAgB;AACpB;;IAEI;QACI,sBAAsB;QACtB,WAAW;IACf;;IAEA;QACI,iBAAiB;QACjB,WAAW;IACf;;AAEJ;IACI,kBAAkB;AACtB;;IAEI;QACI,qBAAqB;IACzB;;AAEJ;IACI,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,sBAAsB;AAC1B;;IAEI;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;AAEJ;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,aAAa;IACb,+BAA+B,EAAE,yCAAyC;AAC9E;;AAEA;IACI,SAAO;IACP,aAAa;IACb,gBAAgB;AACpB;AACA,uCAAuC;;AAEvC;IACI,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,yCAAyC;AAC7C;;IAEI;QACI,eAAe;QACf,cAAc;QACd,mBAAmB;QACnB,gCAAgC;QAChC,mBAAmB;IACvB;;AAEJ,qBAAqB;AACrB;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,iCAAiC;AACrC;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,yBAAyB;IACzB,0BAA0B;IAC1B,kBAAkB;IAClB,aAAa;IACb,gBAAgB;AACpB;;AAEA,YAAY;AACZ;IACI,aAAa;IACb,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA,wBAAwB;AACxB;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;AACjB;;AAEA,uBAAuB;AACvB;IACI,yBAAyB;IACzB,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;AAClB;;IAEI;QACI,yBAAyB;QACzB,0BAA0B;QAC1B,cAAc;IAClB;;AAEJ,oBAAoB;AACpB;IACI,yBAAyB;IACzB,8BAA8B;IAC9B,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA,8BAA8B;AAC9B;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,cAAc;AAClB;AACA,gBAAgB;AAChB,4BAA4B;AAC5B,WAAW;AACX;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,yBAAyB;AAC7B;;AAEA,SAAS;AACT;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,eAAe;AACnB;;IAEI;QACI,yBAAyB;QACzB,YAAY;QACZ,kBAAkB;QAClB,kBAAkB;QAClB,eAAe;QACf,iBAAiB;QACjB,aAAa;QACb,mBAAmB;QACnB,QAAQ;IACZ;;QAEI;YACI,yBAAyB;YACzB,YAAY;QAChB;;AAER,iBAAiB;AACjB;IACI,aAAa;IACb,eAAe;IACf,SAAS;AACb;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,qCAAqC;IACrC,aAAa;IACb,kBAAkB;AACtB;;IAEI;QACI,cAAc;IAClB;;IAEA;QACI,mBAAmB;IACvB;;AAEJ;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA,kBAAkB;AAClB;IACI,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;AACd;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;AACrB;;IAEI;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;QACzB,YAAY;IAChB;;IAEA;QACI,yBAAyB;IAC7B;;AAEJ,qBAAqB;AACrB;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,iBAAiB;AACrB;;AAEA,eAAe;AACf;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;AACJ;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;AACnB","sourcesContent":["/* Shared container styles */\n.prearrival-container {\n    padding: 30px;\n    max-width: 1200px;\n    margin: auto;\n    font-family: 'Segoe UI', sans-serif;\n    background: #ffffff;\n}\n\n    /* Title */\n    .prearrival-container h2 {\n        font-size: 24px;\n        margin-bottom: 25px;\n        color: #1e3a8a;\n        text-align: center;\n    }\n\n/* Table styling (common) */\n.prearrival-table {\n    width: 100%;\n    border-collapse: collapse;\n    margin-bottom: 30px;\n    background: #f9fafb;\n    border-radius: 6px;\n    overflow: hidden;\n    box-shadow: 0 1px 3px rgba(0,0,0,0.08);\n}\n\n    .prearrival-table th,\n    .prearrival-table td {\n        padding: 12px 15px;\n        text-align: left;\n        border-bottom: 1px solid #e5e7eb;\n        font-size: 14px;\n    }\n\n    .prearrival-table th {\n        background-color: #e0e7ff;\n        font-weight: 600;\n        color: #1e3a8a;\n    }\n\n    .prearrival-table tr:hover {\n        background-color: #f3f4f6;\n    }\n\n/* View button */\n.view-button {\n    padding: 6px 12px;\n    font-size: 13px;\n    border: none;\n    background-color: #2563eb;\n    color: white;\n    border-radius: 4px;\n    cursor: pointer;\n}\n\n    .view-button:hover {\n        background-color: #1e40af;\n    }\n\n/* View page layout */\n.prearrival-view {\n    background-color: #ffffff;\n    border-radius: 8px;\n    box-shadow: 0 0 6px rgba(0, 0, 0, 0.1);\n    padding: 30px;\n    margin-top: 20px;\n}\n\n/* Section header */\n.detail-section {\n    margin-bottom: 30px;\n}\n\n    .detail-section h3 {\n        font-size: 18px;\n        margin-bottom: 10px;\n        color: #1e3a8a;\n    }\n\n    /* Detail table */\n    .detail-section table {\n        width: 100%;\n        border-collapse: collapse;\n    }\n\n    .detail-section td {\n        padding: 10px;\n        border-bottom: 1px solid #e5e7eb;\n        vertical-align: top;\n        font-size: 14px;\n    }\n\n        .detail-section td:first-child {\n            font-weight: 600;\n            width: 35%;\n            color: #374151;\n        }\n\n/* Links */\na {\n    color: #2563eb;\n    text-decoration: none;\n}\n\n    a:hover {\n        text-decoration: underline;\n    }\n\n/* Not found */\n.not-found {\n    color: #b91c1c;\n    font-weight: bold;\n    text-align: center;\n    padding: 30px;\n}\n\n/* Back link */\n.back-link {\n    margin-top: 30px;\n    text-align: center;\n    font-size: 14px;\n}\n\n.prearrival-container {\n    background-color: #f8f9fb;\n    min-height: 100vh;\n}\n\n.prearrival-dashboard-content {\n    padding: 20px 30px;\n}\n\n.filter-bar {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px;\n    margin-bottom: 15px;\n}\n\n    .filter-bar input {\n        flex: 1 1 200px;\n        padding: 8px;\n        font-size: 14px;\n        border: 1px solid #ccc;\n        border-radius: 4px;\n    }\n\n.table-responsive {\n    width: 100%;\n    overflow-x: auto;\n}\n\n.prearrival-table {\n    width: 100%;\n    border-collapse: collapse;\n    background-color: #fff;\n}\n\n    .prearrival-table th,\n    .prearrival-table td {\n        padding: 12px 10px;\n        border: 1px solid #ddd;\n        text-align: left;\n        white-space: nowrap;\n    }\n\n    .prearrival-table th {\n        background-color: #eaf0ff;\n        font-weight: bold;\n        cursor: pointer;\n    }\n\n.view-btn {\n    background-color: #007bff;\n    border: none;\n    color: white;\n    padding: 6px 10px;\n    border-radius: 4px;\n    cursor: pointer;\n}\n\n    .view-btn:hover {\n        background-color: #0056b3;\n    }\n\n/* Badge Styles */\n.badge {\n    padding: 4px 8px;\n    border-radius: 4px;\n    font-size: 12px;\n    color: white;\n    display: inline-block;\n}\n\n.badge-submitted {\n    background-color: #28a745;\n}\n\n.badge-draft {\n    background-color: #ffc107;\n    color: black;\n}\n\n.badge-cancelled {\n    background-color: #dc3545;\n}\n.full-width {\n    width: 100%;\n}\n\n.table-responsive {\n    overflow-x: auto;\n}\n\n.filter-bar {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px;\n    margin-bottom: 16px;\n}\n\n    .filter-bar input {\n        padding: 8px;\n        width: 180px;\n        border: 1px solid #ccc;\n        border-radius: 4px;\n    }\n\n.badge {\n    padding: 4px 8px;\n    border-radius: 6px;\n    color: white;\n    font-size: 12px;\n    font-weight: 600;\n    text-transform: uppercase;\n}\n\n.badge-submitted {\n    background-color: #28a745;\n}\n\n.badge-draft {\n    background-color: #ffc107;\n    color: black;\n}\n\n.badge-cancelled {\n    background-color: #dc3545;\n}\n\n.view-btn {\n    padding: 4px 10px;\n    background: #007bff;\n    border: none;\n    color: white;\n    border-radius: 4px;\n    cursor: pointer;\n}\n.card-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));\n    gap: 1.5rem;\n    margin-top: 20px;\n}\n\n.info-card {\n    background-color: #fff;\n    border-radius: 8px;\n    padding: 1.25rem;\n    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);\n    transition: 0.3s;\n}\n\n    .info-card h3 {\n        margin-bottom: 0.75rem;\n        color: #333;\n    }\n\n    .info-card p {\n        margin: 0.25rem 0;\n        color: #444;\n    }\n\n.doc-list {\n    padding-left: 1rem;\n}\n\n    .doc-list li {\n        margin-bottom: 0.4rem;\n    }\n\n.status-badge {\n    padding: 0.25rem 0.5rem;\n    border-radius: 4px;\n    font-size: 0.85rem;\n    color: white;\n    background-color: #666;\n}\n\n    .status-badge.submitted {\n        background-color: #2e7d32;\n    }\n\n    .status-badge.draft {\n        background-color: #b71c1c;\n    }\n\n.view-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.back-button {\n    background-color: #ccc;\n    border: none;\n    padding: 0.4rem 0.8rem;\n    border-radius: 5px;\n    cursor: pointer;\n}\n.dashboard-body {\n    display: flex;\n    min-height: calc(100vh - 150px); /* adjust based on header/footer height */\n}\n\n.dashboard-content {\n    flex: 1;\n    padding: 20px;\n    overflow-y: auto;\n}\n/* === ANALYTICS DASHBOARD STYLES === */\n\n.analytics-section {\n    background-color: #ffffff;\n    padding: 25px;\n    border-radius: 10px;\n    margin-bottom: 30px;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);\n}\n\n    .analytics-section h3 {\n        font-size: 20px;\n        color: #1e3a8a;\n        margin-bottom: 16px;\n        border-bottom: 2px solid #e0e7ff;\n        padding-bottom: 6px;\n    }\n\n/* Chart Containers */\n.chart-container {\n    width: 100%;\n    height: 320px;\n    margin-bottom: 20px;\n    background: #f0f4ff;\n    padding: 10px;\n    border-radius: 6px;\n    box-shadow: inset 0 0 3px #cbd5e1;\n}\n\n/* Heatmap specific */\n.heatmap-chart {\n    height: 280px;\n    background-color: #fff3cd;\n    border: 1px dashed #f0ad4e;\n    border-radius: 6px;\n    padding: 12px;\n    overflow-x: auto;\n}\n\n/* Geo Map */\n.geo-map {\n    height: 350px;\n    width: 100%;\n    background-color: #f0f9ff;\n    border-radius: 8px;\n    border: 1px solid #cfe2ff;\n    position: relative;\n}\n\n/* Checklist Pie / Bar */\n.compliance-chart {\n    height: 280px;\n    background: #e3fcef;\n    border: 1px solid #b2f5ea;\n    border-radius: 6px;\n    padding: 10px;\n}\n\n/* Risk/Health Alerts */\n.alert-card {\n    background-color: #fff4e5;\n    border-left: 6px solid #ff9f43;\n    padding: 12px 20px;\n    margin-bottom: 14px;\n    border-radius: 6px;\n    color: #663c00;\n}\n\n    .alert-card.critical {\n        background-color: #fdecea;\n        border-left-color: #e3342f;\n        color: #a00000;\n    }\n\n/* ETA Live Ticker */\n.live-ticker {\n    background-color: #e6f7ff;\n    border-left: 5px solid #007bff;\n    padding: 10px 18px;\n    font-size: 15px;\n    font-weight: 500;\n    border-radius: 4px;\n    margin-bottom: 16px;\n}\n\n/* Responsive Dashboard Grid */\n.dashboard-analytics-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(340px, 1fr));\n    gap: 24px;\n    margin-top: 20px;\n}\n\n.dashboard-header {\n    font-size: 26px;\n    font-weight: bold;\n    color: #1e3a8a;\n    margin-bottom: 20px;\n    text-align: center;\n}\n\n/* Chart Placeholder */\n.chart-placeholder {\n    height: 250px;\n    background-color: #eef2f7;\n    border-radius: 8px;\n    border: 1px dashed #94a3b8;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-style: italic;\n    color: #64748b;\n}\n/* Core Layout */\n/* PreArrivalDashboard.css */\n/* Layout */\n.dashboard {\n    display: flex;\n    flex-direction: column;\n    min-height: 100vh;\n}\n\n.dashboard-body {\n    display: flex;\n    flex-grow: 1;\n    overflow-x: hidden;\n}\n\n.dashboard-content {\n    flex: 1;\n    padding: 20px;\n    background-color: #f9f9f9;\n}\n\n/* Tabs */\n.dashboard-tabs {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-bottom: 15px;\n    flex-wrap: wrap;\n}\n\n    .dashboard-tabs button {\n        background-color: #e0e0e0;\n        border: none;\n        padding: 10px 14px;\n        border-radius: 6px;\n        cursor: pointer;\n        font-weight: bold;\n        display: flex;\n        align-items: center;\n        gap: 6px;\n    }\n\n        .dashboard-tabs button.active {\n            background-color: #2196f3;\n            color: white;\n        }\n\n/* Cards Layout */\n.cards-container {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 20px;\n}\n\n.chart-card {\n    background-color: white;\n    border-radius: 8px;\n    padding: 16px;\n    box-shadow: 0 2px 5px rgba(0,0,0,0.1);\n    flex: 1 1 45%;\n    position: relative;\n}\n\n    .chart-card.full-width {\n        flex: 1 1 100%;\n    }\n\n    .chart-card h3 {\n        margin-bottom: 10px;\n    }\n\n.card-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 8px;\n}\n\n.chart-description {\n    font-size: 13px;\n    color: #666;\n    margin-top: 10px;\n}\n\n/* Map Container */\n.map-card {\n    background-color: white;\n    border-radius: 8px;\n    padding: 16px;\n    margin-top: 20px;\n    box-shadow: 0 2px 5px rgba(0,0,0,0.1);\n}\n\n.leaflet-map {\n    height: 400px;\n    border-radius: 8px;\n    margin-top: 10px;\n    z-index: 0;\n}\n\n/* Alert Cards */\n.alert-card {\n    padding: 20px;\n    border-radius: 8px;\n    margin-bottom: 12px;\n    color: white;\n    font-weight: bold;\n}\n\n    .alert-card.red {\n        background-color: #d32f2f;\n    }\n\n    .alert-card.yellow {\n        background-color: #fbc02d;\n        color: black;\n    }\n\n    .alert-card.orange {\n        background-color: #fb8c00;\n    }\n\n/* Pie Slice Colors */\n.pie-slice-color-0 {\n    fill: #ffc107 !important;\n}\n\n.pie-slice-color-1 {\n    fill: #ab47bc !important;\n}\n\n.pie-slice-color-2 {\n    fill: #29b6f6 !important;\n}\n\n.pie-slice-color-3 {\n    fill: #66bb6a !important;\n}\n\n.pie-slice-color-4 {\n    fill: #ffa726 !important;\n}\n\n.pie-slice-color-5 {\n    fill: #8d6e63 !important;\n}\n\n.filter-message {\n    margin-bottom: 10px;\n    color: #1e88e5;\n    font-weight: bold;\n}\n\n/* Responsive */\n@media screen and (max-width: 768px) {\n    .cards-container {\n        flex-direction: column;\n    }\n\n    .chart-card {\n        flex: 1 1 100%;\n    }\n\n    .dashboard-tabs {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n}\n\n.button {\n    padding: 8px 16px;\n    border: none;\n    background-color: #000000;\n    color: white;\n    font-weight: 600;\n    border-radius: 4px;\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
